import React, { useRef, useEffect, useMemo } from "react";

function SignupPageCTA({ contestPageDetails, contest_id, member }) {
  const session_member = sessionStorage.getItem("member_" + contest_id);
  const embedRef = useRef(null);

  useEffect(() => {
    if (!embedRef.current) return;

    const resizeIframes = () => {
      const iframes = embedRef.current.querySelectorAll("iframe");
      iframes.forEach((iframe) => {
        iframe.style.width = "100%";
        iframe.style.height = "294px";
        iframe.style.maxWidth = "735px";
        iframe.style.borderRadius = "10px";
      });
    };

    setTimeout(resizeIframes, 100);
  }, [contestPageDetails?.signup_embed, member]);

  const videoContent = useMemo(() => {
    if (session_member !== null && contestPageDetails.login_status) return null;

    if (contestPageDetails.signup_cta === "signupvideoembed") {
      return (
        <div className="embedref-xl  mb-[1rem] max-w-[735px] w-full">
          <div
            ref={embedRef}
            dangerouslySetInnerHTML={{
              __html: contestPageDetails.signup_embed,
            }}
            className="w-full h-[294px]"
          />
        </div>
      );
    }

    if (contestPageDetails.signup_cta === "signupvideourl") {
      const yturl = isYouTubeUrl(contestPageDetails.signup_url);
      if (yturl) {
        const ytid = getYouTubeVideoId(contestPageDetails.signup_url);
        return (
          <iframe
            title="video"
            frameBorder="0"
            width="100%"
            height="294px"
            className="rounded-xl mb-[1rem] max-w-[735px]"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            src={`https://www.youtube.com/embed/${ytid}`}
          ></iframe>
        );
      }

      const vimeourl = isVimeoUrl(contestPageDetails.signup_url);
      if (vimeourl) {
        const vimeoid = getVimeoVideoId(contestPageDetails.signup_url);
        return (
          <iframe
            title="video"
            frameBorder="0"
            width="100%"
            height="294px"
            className="rounded-xl mb-[1rem] max-w-[735px]"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            src={`https://player.vimeo.com/video/${vimeoid}`}
          ></iframe>
        );
      }

      const mp4url = isValidMediaUrl(contestPageDetails.signup_url);
      if (mp4url) {
        return (
          <video
            style={{ padding: "3%" }}
            poster={contestPageDetails?.signup_thumb_image}
            controls
            className="rounded-xl mb-[1rem]"
          >
            <source src={contestPageDetails.signup_url} />
          </video>
        );
      }
    }

    if (contestPageDetails.signup_cta === "signupimage") {
      return (
        <img
          src={contestPageDetails.signup_image}
          alt="signup-img"
          className="w-full h-[145px] md:h-[294px] max-w-[735px] rounded-md"
        />
      );
    }

    return null;
  }, [contestPageDetails, session_member]);

  return <div className="mt-2">{videoContent}</div>;
}

function getYouTubeVideoId(url) {
  const regex = /(?:youtube\.com.*[?&]v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
}

function isYouTubeUrl(url) {
  return /^(https?:\/\/)?(www\.)?(youtube|youtu|youtube-nocookie|youtu.be)\.(com|be)/.test(
    url
  );
}

function isValidMediaUrl(url) {
  return /\.(mp4|webm)$/i.test(url);
}

function isVimeoUrl(url) {
  return /^(https?:\/\/)?(www\.)?vimeo\.com\/\d+/.test(url);
}

function getVimeoVideoId(url) {
  const match = url.match(/vimeo\.com\/(\d+)/);
  return match ? match[1] : null;
}

export default SignupPageCTA;
